module.exports = __webpack_public_path__ + "d7bf50c553f496c1329589f7e1195af4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-9.png
// module id = 2167
// module chunks = 0